import { JointlyDocType } from '@/modules/entity/components/individual/jointly/JointlyIdentificationDocs.tsx';
import {
  OnboardingRoadItem,
  getNavProgressShareholder,
} from '@/modules/issuer-dashboard/components/holder-create/roadsTypes.tsx';
import { AdvisorAccessHolder } from '@/modules/issuer-dashboard/components/holder-create/tabs/AdvisorAccessHolder.tsx';
import {
  AdviserDetailsHolder,
  AdvisorDocType,
} from '@/modules/issuer-dashboard/components/holder-create/tabs/AdvisorDetailsHolder.tsx';
import { AssociationDetailsHolder } from '@/modules/issuer-dashboard/components/holder-create/tabs/AssociationDetailsHolder.tsx';
import { CompanyCRSHolder } from '@/modules/issuer-dashboard/components/holder-create/tabs/CompanyCRSHolder.tsx';
import { CompanyDetailsHolder } from '@/modules/issuer-dashboard/components/holder-create/tabs/CompanyDetailsHolder.tsx';
import { ConfirmationHolder } from '@/modules/issuer-dashboard/components/holder-create/tabs/ConfirmationHolder.tsx';
import { ContactHolderDetails } from '@/modules/issuer-dashboard/components/holder-create/tabs/ContactHolderDetails.tsx';
import { IdentificationDocumentsHolder } from '@/modules/issuer-dashboard/components/holder-create/tabs/IdentificationDocumentsHolder.tsx';
import { JointlyContactHolderDetails } from '@/modules/issuer-dashboard/components/holder-create/tabs/JointlyContactHolderDetails.tsx';
import { JointlyIdentificationHolderDetails } from '@/modules/issuer-dashboard/components/holder-create/tabs/JointlyIdentificationHolderDetails.tsx';
import { JointlyInvestorDetailsPageHolder } from '@/modules/issuer-dashboard/components/holder-create/tabs/JointlyInvestorDetailsPageHolder.tsx';
import { JointlyTaxInformationHolder } from '@/modules/issuer-dashboard/components/holder-create/tabs/JointlyTaxInformationHolder.tsx';
import { MappedTrusteeHolder } from '@/modules/issuer-dashboard/components/holder-create/tabs/MappedTrusteeHolder.tsx';
import { OptionalStepsHolder } from '@/modules/issuer-dashboard/components/holder-create/tabs/OptionalStepsHolder.tsx';
import { PartnershipDetailsHolder } from '@/modules/issuer-dashboard/components/holder-create/tabs/PartnershipDetailsHolder.tsx';
import { PaymentInstructionsHolder } from '@/modules/issuer-dashboard/components/holder-create/tabs/PaymentInstructionsHolder.tsx';
import { PersonIdentificationDocumentsHolder } from '@/modules/issuer-dashboard/components/holder-create/tabs/PersonIdentificationDocumentsHolder.tsx';
import { PersonIndividualHolderDetails } from '@/modules/issuer-dashboard/components/holder-create/tabs/PersonIndividualHolderDetails.tsx';
import { SmsfDetailsHolder } from '@/modules/issuer-dashboard/components/holder-create/tabs/SmsfDetailsHolder.tsx';
import { TaxInformationHolder } from '@/modules/issuer-dashboard/components/holder-create/tabs/TaxInformationHolder.tsx';
import { TaxReportHolder } from '@/modules/issuer-dashboard/components/holder-create/tabs/TaxReportHolder.tsx';
import { TrustDetailsHolder } from '@/modules/issuer-dashboard/components/holder-create/tabs/TrustDetailsHolder.tsx';
import {
  WholesaleCertificateDocType,
  WholesaleCertificateHolder,
} from '@/modules/issuer-dashboard/components/holder-create/tabs/WholesaleCertificateHolder.tsx';
import { EntityStatus, EntityType } from 'api';

export const individualRoad: OnboardingRoadItem[] = [
  {
    component: ContactHolderDetails,
    entity_type_prefix: 'individual_entity_details',
    navName: 'Contact details',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed = !!data?.phone_number && !!data?.entity_name && !!data.preferred_contact_way;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: PersonIndividualHolderDetails,
    entity_type_prefix: 'individual_entity_details',
    navName: 'Individual details',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed = !!data?.individual_entity_details?.first_name;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: PersonIdentificationDocumentsHolder,
    entity_type_prefix: 'individual_entity_details',
    navName: 'Identification documents',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed =
        (!!data?.individual_entity_details?.passport_number &&
          !!data?.document_files?.find(item => item.type === 'passport')) ||
        (!!data?.individual_entity_details?.driver_license_number &&
          !!data?.document_files?.find(item => item.type === 'driver_license_front') &&
          !!data?.document_files?.find(item => item.type === 'driver_license_back')) ||
        (!!data?.individual_entity_details?.medicare_card_number &&
          !!data?.document_files?.find(item => item.type === 'medicare'));

      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: TaxInformationHolder,
    entity_type_prefix: 'individual_entity_details',
    navName: 'Tax information',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed = (data?.individual_entity_details?.tax_residence?.length || 0) > 0;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: TaxReportHolder,
    entity_type_prefix: 'individual_entity_details',
    navName: 'Tax report information',
    allowSkip: true,
    getNavProgress: () => {
      const completed = true;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: OptionalStepsHolder,
    entity_type_prefix: 'individual_entity_details',
    optionalStepsProps: {
      entity_type_prefix: 'individual_entity_details',
      field_name: 'is_managed_by_another_institution',
      title: 'Is this entity managed by another Financial Institution?',
      subroad: [CompanyCRSHolder],
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
    },
    navName: 'Investment entity status',
    allowSkip: true,
    getNavProgress: ({ data, getSubStep, step }) => {
      const allSubStep = 1;
      const currentSubStep = getSubStep(step);
      const percent = currentSubStep === 0 ? 100 : ((currentSubStep + 1) / (allSubStep + 1)) * 100;
      const completed =
        !!data?.individual_entity_details?.crs_status ||
        data?.individual_entity_details?.is_managed_by_another_institution === false;
      return {
        percent,
        completed,
      };
    },
  },
  {
    component: OptionalStepsHolder,
    entity_type_prefix: 'individual_entity_details',
    optionalStepsProps: {
      entity_type_prefix: 'individual_entity_details',
      field_name: 'is_jointly',
      title: 'Are you investing as an individual or investing jointly?',
      subroad: [
        JointlyInvestorDetailsPageHolder,
        JointlyContactHolderDetails,
        JointlyIdentificationHolderDetails,
        JointlyTaxInformationHolder,
      ],
      options: [
        { label: 'Individually', value: false },
        { label: 'Jointly', value: true },
      ],
    },
    navName: 'Individual / Jointly',
    allowSkip: true,
    getNavProgress: ({ data, getSubStep, step }) => {
      const allSubStep = 4;
      const currentSubStep = getSubStep(step);
      const percent = currentSubStep === 0 ? 100 : ((currentSubStep + 1) / (allSubStep + 1)) * 100;
      const currentDocuments =
        (data?.document_files || []).filter(
          item =>
            item.type === JointlyDocType.JointlyPassport ||
            item.type === JointlyDocType.JointlyDriverLicense,
        )?.length > 0;
      const completed =
        (!!data?.individual_entity_details?.jointly?.first_name &&
          !!data?.individual_entity_details?.jointly?.phone_number &&
          (data?.individual_entity_details?.jointly?.tax_residence?.length || 0) > 0 &&
          currentDocuments) ||
        data?.individual_entity_details?.is_jointly === false;
      return {
        percent,
        completed,
      };
    },
  },
  {
    component: PaymentInstructionsHolder,
    entity_type_prefix: 'individual_entity_details',
    navName: 'Payment instructions',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed = !!data?.bank_account_name;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: OptionalStepsHolder,
    entity_type_prefix: 'individual_entity_details',
    optionalStepsProps: {
      entity_type_prefix: 'individual_entity_details',
      field_name: 'is_advisor',
      title: 'Do you want someone else to access this account on your behalf?',
      description: 'For example: an accountant or financial advisor',
      subroad: [AdvisorAccessHolder, AdviserDetailsHolder],
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
    },
    navName: 'Advisor details',
    allowSkip: true,
    getNavProgress: ({ data, getSubStep, step }) => {
      const allSubStep = 2;
      const currentSubStep = getSubStep(step);
      const percent = currentSubStep === 0 ? 100 : ((currentSubStep + 1) / (allSubStep + 1)) * 100;
      const document = data?.document_files?.find(
        ({ type }) => type === AdvisorDocType.CompanyAdvisorDocument,
      );
      const completed =
        (!!document && !!data?.individual_entity_details?.name_authorized_representative) ||
        data?.individual_entity_details?.is_advisor === false;
      return {
        percent,
        completed,
      };
    },
  },
  {
    component: OptionalStepsHolder,
    entity_type_prefix: 'individual_entity_details',
    optionalStepsProps: {
      entity_type_prefix: 'individual_entity_details',
      field_name: 'is_wholesale',
      title: 'Are you Wholesale investor?',
      subroad: [WholesaleCertificateHolder],
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
    },
    navName: 'Wholesale investor details',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const document = (data?.document_files || [])?.filter(
        item => item.type === WholesaleCertificateDocType.Certificate,
      );
      const completed =
        (document?.length > 0 && !!data?.individual_entity_details?.wholesale_type) ||
        data?.individual_entity_details?.is_wholesale === false;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: ConfirmationHolder,
    entity_type_prefix: 'individual_entity_details',
    navName: 'Confirmation',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed = !!data?.status && data?.status !== EntityStatus.EntityCreation;
      return {
        percent: 100,
        completed,
      };
    },
  },
  // {
  //   component: CompletionInformationHolder,
  //   navName: 'Completion',
  //   entity_type_prefix: 'individual_entity_details',
  //   allowSkip: true,
  //   getNavProgress: () => {
  //     return {
  //       completed: false,
  //       percent: 100,
  //     };
  //   },
  // },
];

export const companyRoad: OnboardingRoadItem[] = [
  {
    component: ContactHolderDetails,
    entity_type_prefix: 'company_entity_details',
    navName: 'Contact details',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed =
        !!data?.phone_number &&
        !!data?.company_entity_details?.contact_name &&
        !!data.preferred_contact_way;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: CompanyDetailsHolder,
    entity_type_prefix: 'company_entity_details',
    navName: 'Company details',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed = !!data?.company_entity_details?.company_name;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: IdentificationDocumentsHolder,
    entity_type_prefix: 'company_entity_details',
    label: 'Please upload document',
    title: 'Company extract',
    navName: 'Company extract',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed =
        (data?.document_files?.filter(
          item => item.type === 'company_entity_details_identification_document',
        )?.length ?? 0) > 0;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: TaxInformationHolder,
    entity_type_prefix: 'company_entity_details',
    navName: 'Tax information',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed = (data?.company_entity_details?.tax_residence?.length || 0) > 0;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: TaxReportHolder,
    entity_type_prefix: 'company_entity_details',
    navName: 'Tax report information',
    allowSkip: true,
    getNavProgress: () => {
      const completed = true;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: OptionalStepsHolder,
    entity_type_prefix: 'company_entity_details',
    optionalStepsProps: {
      entity_type_prefix: 'company_entity_details',
      field_name: 'is_managed_by_another_institution',
      title: 'Is this entity managed by another Financial Institution?',
      subroad: [CompanyCRSHolder],
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
    },
    navName: 'Investment entity status',
    allowSkip: true,
    getNavProgress: ({ data, getSubStep, step }) => {
      const allSubStep = 1;
      const currentSubStep = getSubStep(step);
      const percent = currentSubStep === 0 ? 100 : ((currentSubStep + 1) / (allSubStep + 1)) * 100;
      const completed =
        !!data?.company_entity_details?.crs_status ||
        data?.company_entity_details?.is_managed_by_another_institution === false;
      return {
        percent,
        completed,
      };
    },
  },
  {
    component: PaymentInstructionsHolder,
    entity_type_prefix: 'company_entity_details',
    navName: 'Payment instructions',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed = !!data?.bank_account_name;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: MappedTrusteeHolder,
    entity_type_prefix: 'company_entity_details',
    person_details_key: 'directors',
    label: 'Please upload document',
    optionalStepsProps: {
      entity_type_prefix: 'company_entity_details',
      label: 'Company extract document',
      field_name: 'directors',
      title: '',
      subroad: [],
      options: [],
    },
    navName: 'Directors details',
    allowSkip: true,
    getNavProgress: props => {
      return getNavProgressShareholder({
        ...props,
        person_details_key: 'directors',
        entity_type_prefix: 'company_entity_details',
      });
    },
  },
  {
    component: MappedTrusteeHolder,
    entity_type_prefix: 'company_entity_details',
    person_details_key: 'shareholders',
    label: 'Please upload document',
    optionalStepsProps: {
      entity_type_prefix: 'company_entity_details',
      label: 'Company extract document',
      field_name: 'shareholders',
      title: '',
      subroad: [],
      options: [],
    },
    navName: 'Shareholders details',
    allowSkip: true,
    getNavProgress: props => {
      return getNavProgressShareholder({
        ...props,
        entity_type_prefix: 'company_entity_details',
        person_details_key: 'shareholders',
      });
    },
  },
  {
    component: OptionalStepsHolder,
    entity_type_prefix: 'company_entity_details',
    optionalStepsProps: {
      entity_type_prefix: 'company_entity_details',
      field_name: 'is_advisor',
      title: 'Do you want someone else to access this account on your behalf?',
      description: 'For example: an accountant or financial advisor',
      subroad: [AdvisorAccessHolder, AdviserDetailsHolder],
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
    },
    navName: 'Advisor details',
    allowSkip: true,
    getNavProgress: ({ data, getSubStep, step }) => {
      const allSubStep = 2;
      const currentSubStep = getSubStep(step);
      const percent = currentSubStep === 0 ? 100 : ((currentSubStep + 1) / (allSubStep + 1)) * 100;
      const document = data?.document_files?.find(
        ({ type }) => type === AdvisorDocType.CompanyAdvisorDocument,
      );
      const completed =
        (!!document && !!data?.company_entity_details?.name_authorized_representative) ||
        data?.company_entity_details?.is_advisor === false;
      return {
        percent,
        completed,
      };
    },
  },
  {
    component: OptionalStepsHolder,
    entity_type_prefix: 'company_entity_details',
    optionalStepsProps: {
      entity_type_prefix: 'company_entity_details',
      field_name: 'is_wholesale',
      title: 'Are you Wholesale investor?',
      subroad: [WholesaleCertificateHolder],
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
    },
    navName: 'Wholesale investor details',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const document = (data?.document_files || [])?.filter(
        item => item.type === WholesaleCertificateDocType.Certificate,
      );
      const completed =
        (document?.length > 0 && !!data?.company_entity_details?.wholesale_type) ||
        data?.company_entity_details?.is_wholesale === false;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: ConfirmationHolder,
    entity_type_prefix: 'company_entity_details',
    navName: 'Confirmation',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed = !!data?.status && data?.status !== EntityStatus.EntityCreation;
      return {
        percent: 100,
        completed,
      };
    },
  },
  // {
  //   component: CompletionInformationHolder,
  //   navName: 'Completion',
  //   entity_type_prefix: 'company_entity_details',
  //   allowSkip: true,
  //   getNavProgress: () => {
  //     return {
  //       completed: false,
  //       percent: 100,
  //     };
  //   },
  // },
];

export const trustRoad: OnboardingRoadItem[] = [
  {
    component: ContactHolderDetails,
    entity_type_prefix: 'trust_entity_details',
    navName: 'Contact details',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed =
        !!data?.phone_number &&
        !!data?.trust_entity_details?.contact_name &&
        !!data.preferred_contact_way;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: TrustDetailsHolder,
    entity_type_prefix: 'trust_entity_details',
    navName: 'Trust details',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed = !!data?.trust_entity_details?.company_name;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: IdentificationDocumentsHolder,
    entity_type_prefix: 'trust_entity_details',
    label: 'Please upload document',
    title: 'Trust deed document',
    navName: 'Trust deed document',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed =
        (data?.document_files?.filter(
          item => item.type === `trust_entity_details_identification_document`,
        )?.length ?? 0) > 0;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: TaxInformationHolder,
    entity_type_prefix: 'trust_entity_details',
    navName: 'Tax information',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed = (data?.trust_entity_details?.tax_residence?.length || 0) > 0;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: TaxReportHolder,
    entity_type_prefix: 'trust_entity_details',
    navName: 'Tax report information',
    allowSkip: true,
    getNavProgress: () => {
      const completed = true;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: OptionalStepsHolder,
    entity_type_prefix: 'trust_entity_details',
    optionalStepsProps: {
      entity_type_prefix: 'trust_entity_details',
      field_name: 'is_managed_by_another_institution',
      title: 'Is this entity managed by another Financial Institution?',
      subroad: [CompanyCRSHolder],
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
    },
    navName: 'Investment entity status',
    allowSkip: true,
    getNavProgress: ({ data, getSubStep, step }) => {
      const allSubStep = 1;
      const currentSubStep = getSubStep(step);
      const percent = currentSubStep === 0 ? 100 : ((currentSubStep + 1) / (allSubStep + 1)) * 100;
      const completed =
        !!data?.trust_entity_details?.crs_status ||
        data?.trust_entity_details?.is_managed_by_another_institution === false;
      return {
        percent,
        completed,
      };
    },
  },
  {
    component: PaymentInstructionsHolder,
    entity_type_prefix: 'trust_entity_details',
    navName: 'Payment instructions',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed = !!data?.bank_account_name;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: MappedTrusteeHolder,
    entity_type_prefix: 'trust_entity_details',
    person_details_key: 'trustee',
    label: 'Please upload document',
    optionalStepsProps: {
      entity_type_prefix: 'trust_entity_details',
      label: 'Company extract document',
      field_name: 'trustee',
      title: '',
      subroad: [],
      options: [],
    },
    navName: 'Trustee details',
    allowSkip: true,
    getNavProgress: props => {
      return getNavProgressShareholder({
        ...props,
        person_details_key: 'trustee',
        entity_type_prefix: 'trust_entity_details',
      });
    },
  },
  {
    component: MappedTrusteeHolder,
    entity_type_prefix: 'trust_entity_details',
    person_details_key: 'beneficiaries',
    label: 'Please upload document',
    optionalStepsProps: {
      entity_type_prefix: 'trust_entity_details',
      label: 'Company extract document',
      field_name: 'beneficiaries',
      title: '',
      subroad: [],
      options: [],
    },
    navName: 'Beneficiaries details',
    allowSkip: true,
    getNavProgress: props => {
      return getNavProgressShareholder({
        ...props,
        person_details_key: 'beneficiaries',
        entity_type_prefix: 'trust_entity_details',
      });
    },
  },
  {
    component: MappedTrusteeHolder,
    entity_type_prefix: 'trust_entity_details',
    person_details_key: 'settlors',
    label: 'Please upload document',
    optionalStepsProps: {
      entity_type_prefix: 'trust_entity_details',
      label: 'Company extract document',
      field_name: 'settlors',
      title: '',
      subroad: [],
      options: [],
    },
    navName: 'Settlors details',
    allowSkip: true,
    getNavProgress: props => {
      return getNavProgressShareholder({
        ...props,
        person_details_key: 'settlors',
        entity_type_prefix: 'trust_entity_details',
      });
    },
  },
  {
    component: OptionalStepsHolder,
    entity_type_prefix: 'trust_entity_details',
    optionalStepsProps: {
      entity_type_prefix: 'trust_entity_details',
      field_name: 'is_advisor',
      title: 'Do you want someone else to access this account on your behalf?',
      description: 'For example: an accountant or financial advisor',
      subroad: [AdvisorAccessHolder, AdviserDetailsHolder],
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
    },
    navName: 'Advisor details',
    allowSkip: true,
    getNavProgress: ({ data, getSubStep, step }) => {
      const allSubStep = 2;
      const currentSubStep = getSubStep(step);
      const percent = currentSubStep === 0 ? 100 : ((currentSubStep + 1) / (allSubStep + 1)) * 100;
      const document = data?.document_files?.find(
        ({ type }) => type === AdvisorDocType.CompanyAdvisorDocument,
      );
      const completed =
        (!!document && !!data?.trust_entity_details?.name_authorized_representative) ||
        data?.trust_entity_details?.is_advisor === false;
      return {
        percent,
        completed,
      };
    },
  },
  {
    component: OptionalStepsHolder,
    entity_type_prefix: 'trust_entity_details',
    optionalStepsProps: {
      entity_type_prefix: 'trust_entity_details',
      field_name: 'is_wholesale',
      title: 'Are you Wholesale investor?',
      subroad: [WholesaleCertificateHolder],
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
    },
    navName: 'Wholesale investor details',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const document = (data?.document_files || [])?.filter(
        item => item.type === WholesaleCertificateDocType.Certificate,
      );
      const completed =
        (document?.length > 0 && !!data?.trust_entity_details?.wholesale_type) ||
        data?.trust_entity_details?.is_wholesale === false;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: ConfirmationHolder,
    entity_type_prefix: 'trust_entity_details',
    navName: 'Confirmation',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed = !!data?.status && data?.status !== EntityStatus.EntityCreation;
      return {
        percent: 100,
        completed,
      };
    },
  },
  // {
  //   component: CompletionInformationHolder,
  //   navName: 'Completion',
  //   entity_type_prefix: 'trust_entity_details',
  //   allowSkip: true,
  //   getNavProgress: () => {
  //     return {
  //       completed: false,
  //       percent: 100,
  //     };
  //   },
  // },
];

export const smsfRoad: OnboardingRoadItem[] = [
  {
    component: ContactHolderDetails,
    entity_type_prefix: 'smsf_entity_details',
    navName: 'Contact details',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed =
        !!data?.phone_number &&
        !!data?.smsf_entity_details?.contact_name &&
        !!data.preferred_contact_way;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: SmsfDetailsHolder,
    entity_type_prefix: 'smsf_entity_details',
    navName: 'Self Managed Superannuation Fund details',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed = !!data?.smsf_entity_details?.company_name;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: IdentificationDocumentsHolder,
    entity_type_prefix: 'smsf_entity_details',
    label: 'Please upload document',
    title: 'Trust deed document',
    navName: 'Trust deed document',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed =
        (data?.document_files?.filter(
          item => item.type === `smsf_entity_details_identification_document`,
        )?.length ?? 0) > 0;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: TaxInformationHolder,
    entity_type_prefix: 'smsf_entity_details',
    navName: 'Tax information',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed = (data?.smsf_entity_details?.tax_residence?.length || 0) > 0;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: TaxReportHolder,
    entity_type_prefix: 'smsf_entity_details',
    navName: 'Tax report information',
    allowSkip: true,
    getNavProgress: () => {
      const completed = true;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: OptionalStepsHolder,
    entity_type_prefix: 'smsf_entity_details',
    optionalStepsProps: {
      entity_type_prefix: 'smsf_entity_details',
      field_name: 'is_managed_by_another_institution',
      title: 'Is this entity managed by another Financial Institution?',
      subroad: [CompanyCRSHolder],
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
    },
    navName: 'Investment entity status',
    allowSkip: true,
    getNavProgress: ({ data, getSubStep, step }) => {
      const allSubStep = 1;
      const currentSubStep = getSubStep(step);
      const percent = currentSubStep === 0 ? 100 : ((currentSubStep + 1) / (allSubStep + 1)) * 100;
      const completed =
        !!data?.smsf_entity_details?.crs_status ||
        data?.smsf_entity_details?.is_managed_by_another_institution === false;
      return {
        percent,
        completed,
      };
    },
  },
  {
    component: PaymentInstructionsHolder,
    entity_type_prefix: 'smsf_entity_details',
    navName: 'Payment instructions',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed = !!data?.bank_account_name;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: MappedTrusteeHolder,
    entity_type_prefix: 'smsf_entity_details',
    person_details_key: 'trustee',
    label: 'Please upload document',
    optionalStepsProps: {
      entity_type_prefix: 'smsf_entity_details',
      label: 'Company extract document',
      field_name: 'trustee',
      title: '',
      subroad: [],
      options: [],
    },
    navName: 'Trustee details',
    allowSkip: true,
    getNavProgress: props => {
      return getNavProgressShareholder({
        ...props,
        person_details_key: 'trustee',
        entity_type_prefix: 'smsf_entity_details',
      });
    },
  },
  {
    component: MappedTrusteeHolder,
    entity_type_prefix: 'smsf_entity_details',
    person_details_key: 'beneficiaries',
    label: 'Please upload document',
    optionalStepsProps: {
      entity_type_prefix: 'smsf_entity_details',
      label: 'Company extract document',
      field_name: 'beneficiaries',
      title: '',
      subroad: [],
      options: [],
    },
    navName: 'Beneficiaries details',
    allowSkip: true,
    getNavProgress: props => {
      return getNavProgressShareholder({
        ...props,
        person_details_key: 'beneficiaries',
        entity_type_prefix: 'smsf_entity_details',
      });
    },
  },
  {
    component: MappedTrusteeHolder,
    entity_type_prefix: 'smsf_entity_details',
    person_details_key: 'settlors',
    label: 'Please upload document',
    optionalStepsProps: {
      entity_type_prefix: 'smsf_entity_details',
      label: 'Company extract document',
      field_name: 'settlors',
      title: '',
      subroad: [],
      options: [],
    },
    navName: 'Settlors details',
    allowSkip: true,
    getNavProgress: props => {
      return getNavProgressShareholder({
        ...props,
        person_details_key: 'settlors',
        entity_type_prefix: 'smsf_entity_details',
      });
    },
  },
  {
    component: OptionalStepsHolder,
    entity_type_prefix: 'smsf_entity_details',
    optionalStepsProps: {
      entity_type_prefix: 'smsf_entity_details',
      field_name: 'is_advisor',
      title: 'Do you want someone else to access this account on your behalf?',
      description: 'For example: an accountant or financial advisor',
      subroad: [AdvisorAccessHolder, AdviserDetailsHolder],
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
    },
    navName: 'Advisor details',
    allowSkip: true,
    getNavProgress: ({ data, getSubStep, step }) => {
      const allSubStep = 2;
      const currentSubStep = getSubStep(step);
      const percent = currentSubStep === 0 ? 100 : ((currentSubStep + 1) / (allSubStep + 1)) * 100;
      const document = data?.document_files?.find(
        ({ type }) => type === AdvisorDocType.CompanyAdvisorDocument,
      );
      const completed =
        (!!document && !!data?.smsf_entity_details?.name_authorized_representative) ||
        data?.smsf_entity_details?.is_advisor === false;
      return {
        percent,
        completed,
      };
    },
  },
  {
    component: OptionalStepsHolder,
    entity_type_prefix: 'smsf_entity_details',
    optionalStepsProps: {
      entity_type_prefix: 'smsf_entity_details',
      field_name: 'is_wholesale',
      title: 'Are you Wholesale investor?',
      subroad: [WholesaleCertificateHolder],
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
    },
    navName: 'Wholesale investor details',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const document = (data?.document_files || [])?.filter(
        item => item.type === WholesaleCertificateDocType.Certificate,
      );
      const completed =
        (document?.length > 0 && !!data?.smsf_entity_details?.wholesale_type) ||
        data?.smsf_entity_details?.is_wholesale === false;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: ConfirmationHolder,
    entity_type_prefix: 'smsf_entity_details',
    navName: 'Confirmation',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed = !!data?.status && data?.status !== EntityStatus.EntityCreation;
      return {
        percent: 100,
        completed,
      };
    },
  },
  // {
  //   component: CompletionInformationHolder,
  //   navName: 'Completion',
  //   entity_type_prefix: 'smsf_entity_details',
  //   allowSkip: true,
  //   getNavProgress: () => {
  //     return {
  //       completed: false,
  //       percent: 100,
  //     };
  //   },
  // },
];

export const partnershipRoad: OnboardingRoadItem[] = [
  {
    component: ContactHolderDetails,
    entity_type_prefix: 'partnership_entity_details',
    navName: 'Contact details',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed =
        !!data?.phone_number &&
        !!data?.partnership_entity_details?.contact_name &&
        !!data.preferred_contact_way;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: PartnershipDetailsHolder,
    entity_type_prefix: 'partnership_entity_details',
    navName: 'Partnership details',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed = !!data?.partnership_entity_details?.company_name;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: IdentificationDocumentsHolder,
    entity_type_prefix: 'partnership_entity_details',
    label: 'Please upload document',
    title: 'Partnership agreement',
    navName: 'Partnership agreement',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed =
        (data?.document_files?.filter(
          item => item.type === `partnership_entity_details_identification_document`,
        )?.length ?? 0) > 0;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: TaxInformationHolder,
    entity_type_prefix: 'partnership_entity_details',
    navName: 'Tax information',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed = (data?.partnership_entity_details?.tax_residence?.length || 0) > 0;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: TaxReportHolder,
    entity_type_prefix: 'partnership_entity_details',
    navName: 'Tax report information',
    allowSkip: true,
    getNavProgress: () => {
      const completed = true;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: OptionalStepsHolder,
    entity_type_prefix: 'partnership_entity_details',
    optionalStepsProps: {
      entity_type_prefix: 'partnership_entity_details',
      field_name: 'is_managed_by_another_institution',
      title: 'Is this entity managed by another Financial Institution?',
      subroad: [CompanyCRSHolder],
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
    },
    navName: 'Investment entity status',
    allowSkip: true,
    getNavProgress: ({ data, getSubStep, step }) => {
      const allSubStep = 1;
      const currentSubStep = getSubStep(step);
      const percent = currentSubStep === 0 ? 100 : ((currentSubStep + 1) / (allSubStep + 1)) * 100;
      const completed =
        !!data?.partnership_entity_details?.crs_status ||
        data?.partnership_entity_details?.is_managed_by_another_institution === false;
      return {
        percent,
        completed,
      };
    },
  },
  {
    component: PaymentInstructionsHolder,
    entity_type_prefix: 'partnership_entity_details',
    navName: 'Payment instructions',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed = !!data?.bank_account_name;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: MappedTrusteeHolder,
    entity_type_prefix: 'partnership_entity_details',
    person_details_key: 'stakeholders',
    label: 'Please upload document',
    optionalStepsProps: {
      entity_type_prefix: 'partnership_entity_details',
      label: 'Company extract document',
      field_name: 'stakeholders',
      title: '',
      subroad: [],
      options: [],
    },
    navName: 'Stakeholders details',
    allowSkip: true,
    getNavProgress: props => {
      return getNavProgressShareholder({
        ...props,
        person_details_key: 'stakeholders',
        entity_type_prefix: 'partnership_entity_details',
      });
    },
  },
  {
    component: OptionalStepsHolder,
    entity_type_prefix: 'partnership_entity_details',
    optionalStepsProps: {
      entity_type_prefix: 'partnership_entity_details',
      field_name: 'is_advisor',
      title: 'Do you want someone else to access this account on your behalf?',
      description: 'For example: an accountant or financial advisor',
      subroad: [AdvisorAccessHolder, AdviserDetailsHolder],
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
    },
    navName: 'Advisor details',
    allowSkip: true,
    getNavProgress: ({ data, getSubStep, step }) => {
      const allSubStep = 2;
      const currentSubStep = getSubStep(step);
      const percent = currentSubStep === 0 ? 100 : ((currentSubStep + 1) / (allSubStep + 1)) * 100;
      const document = data?.document_files?.find(
        ({ type }) => type === AdvisorDocType.CompanyAdvisorDocument,
      );
      const completed =
        (!!document && !!data?.partnership_entity_details?.name_authorized_representative) ||
        data?.partnership_entity_details?.is_advisor === false;
      return {
        percent,
        completed,
      };
    },
  },
  {
    component: OptionalStepsHolder,
    entity_type_prefix: 'partnership_entity_details',
    optionalStepsProps: {
      entity_type_prefix: 'partnership_entity_details',
      field_name: 'is_wholesale',
      title: 'Are you Wholesale investor?',
      subroad: [WholesaleCertificateHolder],
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
    },
    navName: 'Wholesale investor details',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const document = (data?.document_files || [])?.filter(
        item => item.type === WholesaleCertificateDocType.Certificate,
      );
      const completed =
        (document?.length > 0 && !!data?.partnership_entity_details?.wholesale_type) ||
        data?.partnership_entity_details?.is_wholesale === false;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: ConfirmationHolder,
    entity_type_prefix: 'partnership_entity_details',
    navName: 'Confirmation',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed = !!data?.status && data?.status !== EntityStatus.EntityCreation;
      return {
        percent: 100,
        completed,
      };
    },
  },
  // {
  //   component: CompletionInformationHolder,
  //   navName: 'Completion',
  //   entity_type_prefix: 'partnership_entity_details',
  //   allowSkip: true,
  //   getNavProgress: () => {
  //     return {
  //       completed: false,
  //       percent: 100,
  //     };
  //   },
  // },
];

export const associationRoad: OnboardingRoadItem[] = [
  {
    component: ContactHolderDetails,
    entity_type_prefix: 'association_entity_details_id',
    navName: 'Contact details',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed =
        !!data?.phone_number &&
        !!data?.association_entity_details_id?.contact_name &&
        !!data.preferred_contact_way;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: AssociationDetailsHolder,
    entity_type_prefix: 'association_entity_details_id',
    navName: 'Association details',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed = !!data?.association_entity_details_id?.company_name;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: TaxInformationHolder,
    entity_type_prefix: 'association_entity_details_id',
    navName: 'Tax information',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed = (data?.association_entity_details_id?.tax_residence?.length || 0) > 0;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: TaxReportHolder,
    entity_type_prefix: 'association_entity_details_id',
    navName: 'Tax report information',
    allowSkip: true,
    getNavProgress: () => {
      const completed = true;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: OptionalStepsHolder,
    entity_type_prefix: 'association_entity_details_id',
    optionalStepsProps: {
      entity_type_prefix: 'association_entity_details_id',
      field_name: 'is_managed_by_another_institution',
      title: 'Is this entity managed by another Financial Institution?',
      subroad: [CompanyCRSHolder],
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
    },
    navName: 'Investment entity status',
    allowSkip: true,
    getNavProgress: ({ data, getSubStep, step }) => {
      const allSubStep = 1;
      const currentSubStep = getSubStep(step);
      const percent = currentSubStep === 0 ? 100 : ((currentSubStep + 1) / (allSubStep + 1)) * 100;
      const completed =
        !!data?.association_entity_details_id?.crs_status ||
        data?.association_entity_details_id?.is_managed_by_another_institution === false;
      return {
        percent,
        completed,
      };
    },
  },
  {
    component: PaymentInstructionsHolder,
    entity_type_prefix: 'association_entity_details_id',
    navName: 'Payment instructions',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed = !!data?.bank_account_name;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: MappedTrusteeHolder,
    entity_type_prefix: 'association_entity_details_id',
    person_details_key: 'officers',
    label: 'Please upload document',
    optionalStepsProps: {
      entity_type_prefix: 'association_entity_details_id',
      label: 'Company extract document',
      field_name: 'officers',
      title: '',
      subroad: [],
      options: [],
    },
    navName: 'Officers details',
    allowSkip: true,
    getNavProgress: props => {
      return getNavProgressShareholder({
        ...props,
        person_details_key: 'officers',
        entity_type_prefix: 'association_entity_details_id',
      });
    },
  },
  {
    component: MappedTrusteeHolder,
    entity_type_prefix: 'association_entity_details_id',
    person_details_key: 'shareholders',
    label: 'Please upload document',
    optionalStepsProps: {
      entity_type_prefix: 'association_entity_details_id',
      label: 'Company extract document',
      field_name: 'shareholders',
      title: '',
      subroad: [],
      options: [],
    },
    navName: 'Shareholders details',
    allowSkip: true,
    getNavProgress: props => {
      return getNavProgressShareholder({
        ...props,
        person_details_key: 'shareholders',
        entity_type_prefix: 'association_entity_details_id',
      });
    },
  },
  {
    component: OptionalStepsHolder,
    entity_type_prefix: 'association_entity_details_id',
    optionalStepsProps: {
      entity_type_prefix: 'association_entity_details_id',
      field_name: 'is_advisor',
      title: 'Do you want someone else to access this account on your behalf?',
      description: 'For example: an accountant or financial advisor',
      subroad: [AdvisorAccessHolder, AdviserDetailsHolder],
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
    },
    navName: 'Advisor details',
    allowSkip: true,
    getNavProgress: ({ data, getSubStep, step }) => {
      const allSubStep = 2;
      const currentSubStep = getSubStep(step);
      const percent = currentSubStep === 0 ? 100 : ((currentSubStep + 1) / (allSubStep + 1)) * 100;
      const document = data?.document_files?.find(
        ({ type }) => type === AdvisorDocType.CompanyAdvisorDocument,
      );
      const completed =
        (!!document && !!data?.association_entity_details_id?.name_authorized_representative) ||
        data?.association_entity_details_id?.is_advisor === false;
      return {
        percent,
        completed,
      };
    },
  },
  {
    component: OptionalStepsHolder,
    entity_type_prefix: 'association_entity_details_id',
    optionalStepsProps: {
      entity_type_prefix: 'association_entity_details_id',
      field_name: 'is_wholesale',
      title: 'Are you Wholesale investor?',
      subroad: [WholesaleCertificateHolder],
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
    },
    navName: 'Wholesale investor details',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const document = (data?.document_files || [])?.filter(
        item => item.type === WholesaleCertificateDocType.Certificate,
      );
      const completed =
        (document?.length > 0 && !!data?.association_entity_details_id?.wholesale_type) ||
        data?.association_entity_details_id?.is_wholesale === false;
      return {
        percent: 100,
        completed,
      };
    },
  },
  {
    component: ConfirmationHolder,
    entity_type_prefix: 'association_entity_details_id',
    navName: 'Confirmation',
    allowSkip: true,
    getNavProgress: ({ data }) => {
      const completed = !!data?.status && data?.status !== EntityStatus.EntityCreation;
      return {
        percent: 100,
        completed,
      };
    },
  },
  // {
  //   component: CompletionInformationHolder,
  //   navName: 'Completion',
  //   entity_type_prefix: 'association_entity_details_id',
  //   allowSkip: true,
  //   getNavProgress: () => {
  //     return {
  //       completed: false,
  //       percent: 100,
  //     };
  //   },
  // },
];

export const allRoadsHolderByType: Record<EntityType, OnboardingRoadItem[]> = {
  individual: individualRoad,
  company: companyRoad,
  trust: trustRoad,
  partnership: partnershipRoad,
  association: associationRoad,
  smsf: smsfRoad,
};
